// src/app/page.tsx
import React, { useEffect } from 'react';
import { AxiosResponse } from 'axios';
import { HeadObj } from '@/objects/Page';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import TituloPrincipalH1 from '@/components/elements/TituloPrincipalH1';
import { pathToSection, traduccionesPorPathHead } from '@/util/internacionalizacion/TraduccionesPorPath';
import ContenidoPrincipal from '@/components/elements/ContenidoPrincipal';
import ArticulosQueries from '@/network/Articulos';
import { axiosBaseURLAPI } from '@/util/NetworkInstance';
import Subtitulo from '@/components/elements/Subtitulo';
import LinkCustom from '@/components/elements/LinkCustom';
import { urlWeb } from '@/util/BaseURL';
import { idiomasDisponibles } from '@/util/Comun';
import { crearSlugBuscarCiudad, generarDescripcionCiudad, generarKeyWordsCiudad } from '@/util/Articulos';

interface HomeProps {
  listaCiudades: string[];
  pathActual: string;
}
const LibrosDeSegundaManoEnTuCiudad: React.FC<HomeProps> = ({ pathActual, listaCiudades }) => {

  const { t } = useTranslation();


  useEffect(() => {

  }, [])


  return (
    <ContenidoPrincipal
      leftComponent={<div>Anuncio</div>}
      centerComponent={
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: "100%" }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <TituloPrincipalH1 texto={t(`contenido:${pathActual}.titulo`)} />
            <Subtitulo texto={t(`contenido:${pathActual}.subtitulo`)} />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', alignContent: 'center', width: "100%", marginTop: "20px" }}>
              {listaCiudades.map((ciudad, index) => {
                if (ciudad === "null") {
                  return null; // Si la ciudad es nula, no renderizar nada
                }
                return (
                  <LinkCustom
                    href={crearSlugBuscarCiudad(ciudad)}
                    key={index}
                    title={t(`contenido:${pathActual}.title_ciudad`, { ciudad: ciudad })}>
                    {ciudad}
                  </LinkCustom>
                );
              })}
            </div>
          </div>
        </div>
      }
      rightComponent={<div>Anuncio 2</div>}
    />
  );
};

export default LibrosDeSegundaManoEnTuCiudad;


//Generacion de articulos en el servidor para SEO
export async function getServerSideProps(context: any) {
  //Traducciones
  let { locale } = context;

  if (!locale) {
    locale = 'es'; // Reemplaza 'es' con tu localización predeterminada
  }

  const pathActual = pathToSection(context.resolvedUrl);
  //console.log('Path actual lo:' + pathActual);
  //console.log('Idioma Cookie:' + getCookiePais(context));
  const headerObj: HeadObj = await traduccionesPorPathHead(context, locale);
  let listaCiudades: string[] = [];

  if (locale === 'es') {
    headerObj.linkCanonical = `${urlWeb}/libros-de-segunda-mano-en-tu-ciudad`;
  } else {
    headerObj.linkCanonical = `${urlWeb}/${locale}/libros-de-segunda-mano-en-tu-ciudad`;
  }

  headerObj.alternates = idiomasDisponibles.map((loc) => {
    if (loc === 'es') {
      return { hreflang: loc, href: `${urlWeb}/libros-de-segunda-mano-en-tu-ciudad` };
    } else {
      return { hreflang: loc, href: `${urlWeb}/${loc}/libros-de-segunda-mano-en-tu-ciudad` };
    }
  });

  try {
    const articulosQueries = new ArticulosQueries(axiosBaseURLAPI());

    const response: AxiosResponse<string[]> = await articulosQueries.obtenerListaCiudadesLibros();
    listaCiudades = response.data;

  } catch (error) {
    console.error('Error al obtener artículos:', error);
  }

  //console.log("ServerSideTranslation " + JSON.stringify(await serverSideTranslations(locale, ['common', "contenido"])));
  return {
    props: {
      headerObj: headerObj, // Pasar el objeto de encabezado
      pathActual: pathActual, //Se le pasa para seleccionar las traducciones propias de esta página (dentro de contenido)
      listaCiudades: listaCiudades,
      ...(await serverSideTranslations(locale, ['common', "contenido", "header"])),
    },
    //revalidate: 60, // Regenera la página cada 60 segundos
  };
}